// Human-readable message from an Axios/FastAPI error. Pydantic 422s arrive as a
// detail ARRAY of {loc, msg} — showing raw would toast "[object Object]".
export function errorDetail(error, fallback = 'Something went wrong') {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    const first = detail[0];
    if (first?.msg) {
      const field = Array.isArray(first.loc) ? first.loc[first.loc.length - 1] : null;
      const msg = String(first.msg).replace(/^Value error,\s*/i, '');
      return field && typeof field === 'string' ? `${field}: ${msg}` : msg;
    }
    return fallback;
  }
  if (typeof detail === 'string') return detail;
  return fallback;
}
